module.exports = new __parcel__URL__("emit-plume--cover.34792feb.jpg").toString();